import React from 'react';
export function Narrative() {
  return <section className="flex flex-col gap-6 py-8 border-t border-stone-200" data-id="element-88">
      <h3 className="font-serif text-2xl font-bold text-[#0F4C3A]" data-id="element-89">
        Te suena esto
      </h3>

      <div className="flex flex-col gap-4 text-lg text-stone-700" data-id="element-90">
        <p data-id="element-91">Son las 7 de la tarde. Terminaste tu última sesión.</p>
        <p data-id="element-92">
          Mañana viene el nene que tartamudea y la semana pasada ya usaste las
          tres fichas que encontraste en un grupo de WhatsApp. Abrís Google.
          Pinterest. Un PDF en inglés que tenés que traducir y adaptar. Una hora
          después tenés algo. No es lo que querías. Pero es lo que hay.
        </p>
        <p className="font-bold text-stone-900 text-xl mt-2" data-id="element-93">
          El problema no sos vos. Es que nunca tuviste un sistema clínico
          completo para trabajar la fluencia del habla.
        </p>
        <p className="text-[#D97757] font-bold text-xl" data-id="element-94">
          Eso es exactamente lo que construimos.
        </p>
      </div>
    </section>;
}